import React from "react";
import ReactModalWrap from "../common/ReactModalWrap";
import styles from "./Modal.module.scss";
import Button from "../common/Button";

export default function ConfirmDeleteAddressModal({ isOpen, close, onYes }) {
  return (
    <ReactModalWrap isOpen={isOpen} close={close}>
      <div className={styles.content}>
        <div className={styles.header} style={{ textAlign: "left" }}>
          Delete address?
        </div>
        <div className={styles.subHeader}>
          This action will remove the address restriction from the user.
        </div>
        <div className={styles.buttonWrap}>
          <Button variant="white" className={styles.button} onClick={() => (onYes ? onYes() : null)}>
            YES
          </Button>
          <Button variant="white" className={styles.button} onClick={() => close()}>
            NO
          </Button>
        </div>
      </div>
    </ReactModalWrap>
  );
}

